import React from 'react';
import { ChartRendererSupabase } from './ChartRendererSupabase';
import {
  ClimateEquityDataService,
  EquityDataPoint,
  EquityDataResolution
} from '../../services/climateEquityDataService';

interface EquityBubbleChartProps {
  data: EquityDataPoint[];
  resolution: EquityDataResolution;
  loading?: boolean;
  error?: string | null;
}

const EquityBubbleChart: React.FC<EquityBubbleChartProps> = ({
  data,
  resolution,
  loading = false,
  error = null
}) => {
  if (loading) {
    return (
      <div className="chart-loading" style={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="loading-spinner"></div>
        <p>Loading climate equity analysis...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="chart-error" style={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: '#dc2626' }}>{error}</p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="chart-no-data" style={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p>No equity data available for this location.</p>
      </div>
    );
  }

  // Transform data using service layer
  let chartData, chartOptions;
  try {
    chartData = ClimateEquityDataService.getBubbleChartData(data);
    chartOptions = ClimateEquityDataService.getChartOptions('bubble', data, resolution);
  } catch (transformError) {
    return (
      <div className="chart-error" style={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: '#dc2626' }}>Error processing chart data: {transformError instanceof Error ? transformError.message : 'Unknown error'}</p>
      </div>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      {/* Resolution info */}
      <div style={{
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        marginBottom: '1rem',
        padding: '0.5rem',
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '0.5rem'
      }}>
        <span style={{ fontSize: '12px', color: '#6b7280' }}>
          Bubble Chart: Education (x-axis) vs Solar (y-axis), EV adoption (bubble size), Insurance coverage (color)
        </span>
        <span style={{ fontSize: '12px', color: '#6b7280', marginLeft: 'auto' }}>
          ({data.length} {resolution === 'city' ? 'cities' : 'census tracts'})
        </span>
      </div>

      <ChartRendererSupabase
        chartData={{
          ...chartData,
          type: 'bubble' // Ensure type is set for Chart.js
        }}
        chartOptions={{
          ...chartOptions,
          type: 'bubble' // Ensure type is set for Chart.js
        }}
        height="400px"
      />
    </div>
  );
};

export default EquityBubbleChart;